// extracted by mini-css-extract-plugin
export default {"spinner":"ContactFormButtonLoading_spinner__m2R0s"};